/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Hero {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Hero as HeroModule } from "@bw/modules"
import { Button } from "@bw/bits"
import { graphql } from "gatsby"

const Hero = ({ title, suptitle, subtitle, buttons, image, imagePosition }) => {
  return (
    <HeroModule
      suptitle={suptitle}
      title={title}
      subtitle={subtitle}
      image={image.url}
      buttons={buttons.map(button => {
        return <Button href="#" label="salut" />
      })}
    />
  )
}

export default Hero

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on HeroModule {
 *   ...HeroModuleFragment
 * }
 *
 * This is also what you will get in the props of your LogoGrid
 * resolver component.
 */
export const query = graphql`
  fragment HeroModuleFragment on HeroModule {
    buttons {
      isExternal
      linkType
      url
      entry {
        slug
      }
    }
    image {
      url
    }
    imagePosition
  }
`
